import React from 'react';

const calculateNextListIndex = (listIndex: number, direction: number, length: number) => {
  let nextListIndex = listIndex + direction;
  // If the next list index is out of bounds, loop back to the beginning or end
  if (nextListIndex < 0) {
    nextListIndex = length - 1;
  } else if (nextListIndex >= length) {
    nextListIndex = 0;
  }
  return nextListIndex;
};

const getNextItem = (menuList: React.RefObject<HTMLUListElement>, isArrowDown: boolean) => {
  const menuItems = Array.from(menuList?.current?.querySelectorAll('li:not([data-selector="list_subheader"])'));
  return isArrowDown ? menuItems[0] : menuItems[menuItems.length - 1];
};

interface IHandleFocusArgs {
  event: React.KeyboardEvent<HTMLLIElement>;
  itemIndex: number;
  listLength: number;
  listIndex: number;
  menuListRefs: React.RefObject<HTMLUListElement>[];
}

export const handleFocusBetweenMenuLists = ({
  event,
  itemIndex,
  listLength,
  listIndex,
  menuListRefs
}: IHandleFocusArgs) => {
  const isLastItem = itemIndex === listLength - 1;
  const isFirstItem = itemIndex === 0;
  const isArrowDown = event.key === 'ArrowDown';
  const isArrowUp = event.key === 'ArrowUp';
  // If the last or first item is focused and the arrow key is pressed, focus the next or previous list
  if ((isLastItem && isArrowDown) || (isFirstItem && isArrowUp)) {
    event.preventDefault();
    const direction = isArrowDown ? 1 : -1;
    const nextListIndex = calculateNextListIndex(listIndex, direction, menuListRefs.length);
    const menuList = menuListRefs[nextListIndex];
    const nextItem = getNextItem(menuList, isArrowDown);
    if (nextItem) {
      setTimeout(() => {
        (nextItem as HTMLElement).focus();
      }, 0);
    }
  }
};

export const getFirstMenuItem = (menuListRefs: React.RefObject<HTMLUListElement>[]): HTMLLIElement => {
  const menuList = menuListRefs?.[0];
  if (!menuList?.current) return null;

  const menuItems = Array.from(menuList.current.querySelectorAll('li:not([data-selector="list_subheader"])'));
  if (menuItems.length === 0) return null;

  return menuItems[0] as HTMLLIElement;
};
